import DelegationDownloadRequest, {
  DelegationDownloadRequestFileFormat,
  DelegationDownloadRequestTimezone,
} from "../../../api/raily/delegation/download/delegation-download.request";
import Timezone from "../../../types/timezone";
import DelegationDownloadParams, {
  DelegationDownloadParamsFileFormat,
} from "./delegation-download-params";

const createFileFormat = (
  format: DelegationDownloadParamsFileFormat,
): DelegationDownloadRequestFileFormat => {
  switch (format) {
    case DelegationDownloadParamsFileFormat.CSV:
      return DelegationDownloadRequestFileFormat.CSV;
    case DelegationDownloadParamsFileFormat.PDF:
      return DelegationDownloadRequestFileFormat.PDF;
  }
};

const createTimezone = (
  timezone: Timezone | undefined,
): DelegationDownloadRequestTimezone | undefined => {
  switch (timezone) {
    case Timezone.EUROPE_WARSAW:
      return DelegationDownloadRequestTimezone.EUROPE_WARSAW;
    case Timezone.UTC:
      return DelegationDownloadRequestTimezone.UTC;
    default:
      return undefined;
  }
};

const create = (
  params: DelegationDownloadParams,
): DelegationDownloadRequest => {
  return {
    fileFormat: createFileFormat(params.fileFormat),
    delegationUuids: params.delegationUuids,
    separator: params.separator,
    timezone: createTimezone(params.timezone),
  };
};

const delegationDownloadParamsFactory = {
  create,
};

export default delegationDownloadParamsFactory;
